import { Check } from 'lucide-react'

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand" aria-label="TodoBack">
      <span className="brand-mark"><Check size={compact ? 18 : 22} strokeWidth={3} /></span>
      {!compact && <span>Todo<span>Back</span></span>}
    </div>
  )
}
